import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { NgxSpinnerService } from "ngx-spinner";
import { RepresentativeUnitsService } from '../representative-units/representative-units.service';
import { RepUnitsAddDialogService } from './rep-units-add-dialog.service';

@Component({
    selector: 'app-rep-units-add-dialog',
    templateUrl: './rep-units-add-dialog.component.html',
    styleUrls: ['./rep-units-add-dialog.component.css'],
    standalone: false
})
export class RepUnitsAddDialogComponent implements OnInit {

  //Date transform
  pipe = new DatePipe('en-US');
  currentDate = moment().format('DD/MM/YYYY');


  //errormessage
  errorMessage: string = "";

  //ngModel
  aMonthlyRep: any = "";
  aSapMatID: any = "";
  aNamc: any = "";
  aFamily: any = "";
  aPart: any = "";
  aPartDesc: any = "";
  aKatashiki: any = "";
  aProdTyp: any = "";
  aExtTimeIn: any = "";
  aExtTimeOut: any = "";
  aComments: any = "";
  aGrpi: any = "";
  screen = 'unit'
  //lst
  namcLst = [];
  famcdLst = [];
  katashikiLst = [];
  prodTypLst = [];

  //response from backend after insert/update records
  response: any;

  //to main page
  message = "Record Added Successfully";

  spinnerMessage = "Please Wait...";
  grpitext: boolean = false;

  constructor(public dialogRef: MatDialogRef<RepUnitsAddDialogComponent>,
    private SpinnerService: NgxSpinnerService, private repUnitsService: RepresentativeUnitsService,
    private repUnitsAddService: RepUnitsAddDialogService) { }

  ngOnInit(): void {
    this.SpinnerService.show();
    this.repUnitsAddService.getNamc().subscribe(data => {
      console.log(data)
      this.SpinnerService.hide();
      this.namcLst = data.payload;
      console.log(this.namcLst)
    });

    if (localStorage.getItem('partnumberpopup')) {
      localStorage.removeItem('partnumberpopup')
    }
    //this.getFamily();

    this.repUnitsAddService.getProdType().subscribe(data => {
      console.log(data)
      this.prodTypLst = data.payload;
    });

    this.getKatashikiByFamCd();
  }

  getFamily(): void {
    if (this.aNamc == undefined) {
      this.aNamc = ""
    }
    if (this.aNamc != "") {
      this.SpinnerService.show();
      this.repUnitsAddService.getFamily(this.aNamc, this.screen).subscribe(data => {
        console.log(data);
        this.SpinnerService.hide();
        this.famcdLst = data.payload;
        this.aFamily = ""
      });
    } else {
      this.famcdLst = []
      this.aFamily = ""
    }
  }

  getKatashikiByFamCd(): void {
    if (this.aFamily == undefined) {
      this.aFamily = ""
    }
    this.repUnitsAddService.getKatashikiByFamCd(this.aFamily).subscribe(data => {
      console.log(data);
      this.katashikiLst = data.payload;
      this.aKatashiki = ""
    });

  }
  //onChangeMethod
  getFamCdByNamc(): void {
    this.getFamily();
  }

  partdescription(partdata) {
    this.errorMessage = ""
    if (this.aPart == "") {
      console.log('1')
      this.aPartDesc = ""
    }
    else if (this.aPart != "") {

      if (this.aPartDesc == "") {
        this.repUnitsAddService.getPartDesc(this.aPart).subscribe(data => {
          console.log(data)
          if (data.payload) {
            this.aPartDesc = data.payload[0].part_desc;
            this.errorMessage = ""
            localStorage.setItem("partnumberpopup", this.aPart);
          }
          else {
            this.errorMessage = "Part Number <" + this.aPart + "> Invalid";
            this.aPart = ""
            this.aPartDesc = ""
          }
          // this.errorMessage = "Part Number Invalid"
          // this.aPartDesc = ""


        });
      }
      else if (this.aPartDesc != "") {
        if (this.aPart != localStorage.getItem('partnumberpopup')) {
          this.repUnitsAddService.getPartDesc(this.aPart).subscribe(data => {
            console.log(data)
            if (data.payload) {
              this.aPartDesc = data.payload[0].part_desc;
              this.errorMessage = ""
              localStorage.setItem("partnumberpopup", this.aPart);
            }
            else {
              this.errorMessage = "Part Number <" + this.aPart + "> Invalid"
              this.aPart = ""
              this.aPartDesc = ""
            }

          });
        }
      } else {
        console.log('9')
        this.repUnitsAddService.getPartDesc(this.aPart).subscribe(data => {
          console.log(data)
          if (data.payload) {
            this.aPartDesc = data.payload[0].part_desc;
            this.errorMessage = ""
            localStorage.setItem("partnumberpopup", this.aPart);
          }
          else {
            this.errorMessage = "Part Number <" + this.aPart + "> Invalid"
            this.aPart = ""
            this.aPartDesc = ""
          }

          });
      }
    }

  }

  //save
  submitRepUnit(): void {

    if (!this.aNamc || !this.aFamily || !this.aPart || !this.aExtTimeIn || !this.aProdTyp) {
      this.errorMessage = "Please enter all mandatory field";
    }
    else if ((this.grpitext == true) && !this.aGrpi) {
      this.errorMessage = "Please enter all mandatory field";
    }
    else if (this.aExtTimeIn && this.aExtTimeOut &&
      this.pipe.transform(this.aExtTimeIn, 'yyyy-MM-dd') > this.pipe.transform(this.aExtTimeOut, 'yyyy-MM-dd')) {
      this.errorMessage = "Extraction Time Out should be greater than or equal to Extraction Time In";
    }
    else {
      this.errorMessage = "";
      if (this.aExtTimeOut == "") {
        this.aExtTimeOut = "9999-12-31"
      }
      let body = {
        part: this.aPart
      }
      this.SpinnerService.show();
      this.repUnitsAddService.PartNumberValidation(body).subscribe(data => {
        console.log(data);
        this.response = data.payload;
        if (this.response[0].result == 'success') {
          // this.aPart = ""
          this.AddExistsCheck();
        } else if (this.response[0].result == 'Partnum_Invalid') {
          this.SpinnerService.hide();
          // this.aPart = ""
          this.errorMessage = "Part Number <" + this.aPart + "> Invalid"

        }
      }, err => {
        console.log(err);
        this.SpinnerService.hide();
      });

    }

  }
  AddExistsCheck() {
    let fileName= localStorage.getItem('Filename')
    let body = {
      namc: this.aNamc,
      family: this.aFamily,
      part: this.aPart,
      grpiCd: this.aGrpi,
      prodtyp: this.aProdTyp,
      "screenNo":"NBPC_9355",
      "fileName" :fileName
    }
    this.SpinnerService.show();
    this.repUnitsAddService.ExistsRepUnitData(body).subscribe(data => {
      console.log(data);
      this.response = data.payload;
      if (this.response[0].result == 'success') {
        this.AddRepunit();
      } else if (this.response[0].result == 'Invalid') {
        this.SpinnerService.hide();
        this.errorMessage = 'Part Number Invalid';
      } else if (this.response[0].result == 'Data Already Exists') {
        this.SpinnerService.hide();
        this.errorMessage = 'Record already Exists!';
      }
    }, err => {
      console.log(err);
      this.SpinnerService.hide();
    });
  }
  AddRepunit() {
    let user = localStorage.getItem('workDayId');
    let mnthly_flg;
    if (this.aMonthlyRep == true) {
      mnthly_flg = 'Y'
    }
    else {
      mnthly_flg = 'N'
    }
    this.errorMessage = '';
    let indateFormat = ''; let outdateFormat = '';
    if (this.aExtTimeIn != "") {
      let d1 = moment(this.aExtTimeIn).format('YYYY-MM-DD')
      let b = d1.split('T')[0]
      let parts = []
      parts = b.split('-');
      let date = new Date(parts[0], parts[1] - 1, parts[2]);
      indateFormat = moment(date).format('YYYY-MM-DD')
      this.aExtTimeIn = date
    }
    if (this.aExtTimeOut != "") {
      let d1 = moment(this.aExtTimeOut).format('YYYY-MM-DD')
      let b = d1.split('T')[0]
      let parts = []
      parts = b.split('-');
      let date = new Date(parts[0], parts[1] - 1, parts[2]);
      outdateFormat = moment(date).format('YYYY-MM-DD')
      this.aExtTimeOut = date
    }
    let cmts;
    if (this.aComments != undefined) {
      cmts = this.aComments.replaceAll("'", "''");
    } else {
      cmts = this.aComments
    }
    let body = {
      monthlyRep: mnthly_flg,
      sapMatId: this.aSapMatID,
      namc: this.aNamc,
      family: this.aFamily,
      part: this.aPart,
      partDesc: this.aPartDesc,
      katashiki: this.aKatashiki,
      prodType: this.aProdTyp,
      extTimeIn: indateFormat,
      extTimeOut: outdateFormat,
      comments:cmts ,
      grpi: this.aGrpi,

    }
    this.SpinnerService.show();
    this.repUnitsAddService.addRepUnitData(body).subscribe(data => {
      console.log(data);
      this.response = data.payload;
      this.SpinnerService.hide();
      if (this.response[0].result == 'success') {
        this.dialogRef.close(this.response[0].result);
      } else {
        this.errorMessage = "Data not Added";
      }
    }, err => {
      console.log(err);
      this.SpinnerService.hide();
    });
  }

  cancel(): void {
    this.message = "";
    this.dialogRef.close({ event: 'Cancel', data: this.message });
  }

  //closealert

  closeAlert(): void {
    this.errorMessage = '';
  }

  getgrpi() {
    console.log(this.aProdTyp)
    if (this.aProdTyp == "AC") {
      this.grpitext = true;
    } else if (this.aProdTyp == "A") {
      this.grpitext = true;
    } else if (this.aProdTyp == "B") {
      this.grpitext = true;
    } else {
      this.grpitext = false;
    }

  }

  clearDate(event, name) {
    event.stopPropagation();
    if (name == 'aExtTimeIn') {
      this.aExtTimeIn = "";
    } else if (name == 'aExtTimeOut') {
      this.aExtTimeOut = "";
    }
  }
}
